import React from 'react'
import { IPaymentMethod } from '../state/Radom'
import { ManagedPaymentMethod, getMethod } from '../util/Managed'
import styled from 'styled-components'
import Tooltip from './Tooltip'
import { AssetIcon } from './AssetIdentity'
import { assetSubtitle, methodNetworkLabel, tickerLabel } from '../util/AssetLabels'

const PaymentMethod = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 14px;
`

const NetworkText = styled.span`
  color: var(--text-soft, #7d8492);
`

export const SelectedMethodIcon = (props: {
  method: ManagedPaymentMethod
  disableToolTip?: boolean
  size?: number
  showNetworkBadge?: boolean
}): React.ReactElement => {
  return <Tooltip
    style={{ maxWidth: 300 }}
    message={assetSubtitle(props.method)}
    disabled={props.disableToolTip}>
    <AssetIcon method={props.method} size={props.size ?? 25} badge={props.showNetworkBadge !== false} />
  </Tooltip>
}

/**
 * An asset as one line: its icon, its ticker, and the network it is on. `includeNetworkName` is kept for callers
 * that still pass it; the network is now part of the label whenever there is one.
 */
const PaymentMethodDisplay = (props: {
  method: IPaymentMethod
  paymentMethod?: ManagedPaymentMethod
  disableTooltip?: boolean
  size?: number
  excludeName?: boolean
  includeNetworkName?: boolean
  showNetworkBadge?: boolean
  style?: React.CSSProperties
}): React.ReactElement => {
  const m = props.paymentMethod ?? getMethod(props.method.network, props.method.token)
  const network = methodNetworkLabel(m)
  return <PaymentMethod style={props.style}>
    <SelectedMethodIcon
      method={m}
      disableToolTip={props.disableTooltip ?? true}
      size={props.size}
      showNetworkBadge={props.showNetworkBadge} />
    {!props.excludeName && <div style={{ marginLeft: 4 }}>
      {tickerLabel(m.ticker)}
      {network && <NetworkText> on {network}</NetworkText>}
    </div>}
  </PaymentMethod>
}

export default PaymentMethodDisplay
